import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Event, EventSeverity } from 'orv-ui-base-lib';

@Component({
	selector: 'app-event-card',
	templateUrl: './event-card.component.html',
	styleUrls: ['./event-card.component.scss']
})
export class EventCardComponent implements OnInit {

	MAXTIMEAGO = 1000 * 60 * 5;
	@Input() event: Event;

	@Input() now: number = 0;

	@Output() action: EventEmitter<any> = new EventEmitter();
	@Output() dismiss: EventEmitter<any> = new EventEmitter();
	@Output() mapSelect: EventEmitter<any> = new EventEmitter();
	@Output() openChat: EventEmitter<any> = new EventEmitter<any>();

	classSeverity: string;

	constructor() { }

	ngOnInit() {
		if (this.event.severity === EventSeverity.FATAL)
			this.classSeverity = 'fatal';
		else if (this.event.severity === EventSeverity.SEVERE)
			this.classSeverity = 'severe';
		else if (this.event.severity === EventSeverity.WARNING)
			this.classSeverity = 'warning';
		else if (this.event.severity === EventSeverity.INFO)
			this.classSeverity = 'info';
		else if (this.event.severity === EventSeverity.COMMAND)
			this.classSeverity = 'command';
	}

	onAction() {
		this.action.emit(this.event);
	}

	onDismiss() {
		this.dismiss.emit(this.event);
	}

	onSelectMap() {
		this.mapSelect.emit(this.event);
	}

	onSelectChat() {
		console.log("Open chat:", this.event);
		this.openChat.emit(this.event.dispatchid);
	}

}
